export default __webpack_public_path__ + "media/images/home/slide_howto_sm-d6a29abbcef5f0f0c5db45a6d74b7406.jpg";